<template>
  <v-col xs="12" sm="12" md="12" lg="12">
    <v-responsive width="100%" v-if="$vuetify.breakpoint.xsOnly" />
    <v-card elevation="5" rounded>
      <v-row class="mx-1 mb-2">
        <base-column :xs="12" :sm="12" :md="4" :lg="3">
          <v-banner class="mt-3 summary" outlined rounded single-line>
            <v-row no-gutters class="mb-3 mt-2">
              <v-col cols="3" xs="3" sm="3" md="3" class="my-auto mx-auto">
                <v-avatar color="primary" size="40">
                  <v-icon color="white">mdi-receipt-text</v-icon>
                </v-avatar>
              </v-col>
              <v-col cols="9" xs="9" sm="9" md="9">
                <h4 class="primary--text ml-2">{{ 0 | currency("", 0, {
                  symbolOnLeft: false
                }) }}</h4>
                <h4 class="ml-2"> Total Purchase Order</h4>
              </v-col>
            </v-row>
          </v-banner>
        </base-column>
        <base-column :xs="12" :sm="12" :md="4" :lg="3">
          <v-banner class="mt-3 summary" outlined rounded single-line>
            <v-row no-gutters class="mb-3 mt-2">
              <v-col cols="3" xs="3" sm="3" md="3" class="my-auto mx-auto">
                <v-avatar color="success" size="40">
                  <v-icon color="white">mdi-progress-clock</v-icon>
                </v-avatar>
              </v-col>
              <v-col cols="9" xs="9" sm="9" md="9">
                <h4 class="success--text ml-2">{{ 0 | currency("", 0, {
                  symbolOnLeft: false
                }) }}</h4>
                <h4 class="ml-2"> ON PROGRESS</h4>
              </v-col>
            </v-row>
          </v-banner>
        </base-column>
        <base-column :xs="12" :sm="12" :md="4" :lg="3">
          <v-banner class="mt-3 summary" outlined rounded single-line>
            <v-row no-gutters class="mb-3 mt-2">
              <v-col cols="3" xs="3" sm="3" md="3" class="my-auto mx-auto">
                <v-avatar color="info" size="40">
                  <v-icon color="white">mdi-text-box</v-icon>
                </v-avatar>
              </v-col>
              <v-col cols="9" xs="9" sm="9" md="9">
                <h4 class="info--text ml-2">{{ 0 | currency("", 0, {
                  symbolOnLeft: false
                }) }}</h4>
                <h4 class="ml-2"> DONE</h4>
              </v-col>
            </v-row>
          </v-banner>
        </base-column>
        <base-column :xs="12" :sm="12" :md="4" :lg="3">
          <v-banner class="mt-3 summary" outlined rounded single-line>
            <v-row no-gutters class="mb-3 mt-2">
              <v-col cols="3" xs="3" sm="3" md="3" class="my-auto mx-auto">
                <v-avatar color="danger" size="40">
                  <v-icon color="white">mdi-text-box</v-icon>
                </v-avatar>
              </v-col>
              <v-col cols="9" xs="9" sm="9" md="9">
                <h4 class="danger--text ml-2">{{ 0 | currency("", 0, {
                  symbolOnLeft: false
                }) }}</h4>
                <h4 class="ml-2"> CANCEL</h4>
              </v-col>
            </v-row>
          </v-banner>
        </base-column>
      </v-row>
      <v-divider class="mx-4 mb-4"></v-divider>
      <v-row class="mx-1 mb-1">
        <v-col xs="12" sm="12" md="2" lg="2">
          <v-text-field type="date" label="From date" outlined dense v-model="search.from_date">
          </v-text-field>
        </v-col>
        <v-col xs="12" sm="12" md="2" lg="2">
          <v-text-field type="date" label="End date" outlined dense v-model="search.end_date">
          </v-text-field>
        </v-col>
        <v-col xs="12" sm="12" md="2" lg="2">
          <v-select :items="branch" item-text="name" item-value="id" outlined dense label="Branch"
            v-model="search.branch_id"></v-select>
        </v-col>
        <v-col xs="12" sm="12" md="2" lg="2">
          <v-select :items="status" outlined dense label="Status" v-model="search.status"></v-select>
        </v-col>
        <v-col xs="12" sm="12" md="2" lg="2">
          <v-text-field label="Search" outlined dense v-model="search.search">
          </v-text-field>
        </v-col>
        <v-col xs="12" sm="12" md="2" lg="2">
          <v-btn small color="darkblue" class="white--text mx-1" @click.stop="init">Submit <v-icon
              right>mdi-magnify</v-icon></v-btn>
          <v-btn small color="secondary" class="white--text mx-1" @click.stop="clear">Clear
            <v-icon right>mdi-close-circle-multiple </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table :loading="loading" :headers="headers" :items="PurchaseOrders.data" class="elevation-1"
        hide-default-footer>
        <template slot="body.append">
          <tr>
            <th colspan="4"></th>
            <th style="font-size: 15px;">{{ sumField('grand_total') | currency("", 0, { symbolOnLeft: false, }) }}</th>
            <th colspan="3"></th>
          </tr>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip color="success" small v-if="item.status == 'ONPROGRESS'">
            ON PROGRESS
          </v-chip>
          <v-chip color="info" small v-else-if="item.status == 'DONE'">
            DONE
          </v-chip>
          <v-chip color="danger" small v-else-if="item.status == 'CANCEL'">
            CANCEL
          </v-chip>
        </template>
        <!-- <template v-slot:[`item.status_invoice`]="{ item }">
          <v-chip color="primary" small v-if="item.status_invoice == 'ONPROGRESS'">
            ON PROGRESS
          </v-chip>
          <v-chip color="secondary" small v-if="item.status_invoice == 'PARTIAL'">
            PARTIAL
          </v-chip>
          <v-chip color="success" small v-else-if="item.status_invoice == 'DONE'">
            DONE
          </v-chip>
          <v-chip color="error" small v-else-if="item.status_invoice == 'CANCEL'">
            CANCEL
          </v-chip>
          <v-chip color="2196F3" small v-else-if="item.status_invoice == 'INVOICED'">
            INVOICED
          </v-chip>
        </template> -->
        <template v-slot:[`item.grand_total`]="{ item }">
          <b>{{ item.grand_total | currency("", 0, { symbolOnLeft: false, }) }}</b>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip color="dark" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mr-2" color="primary" v-bind="attrs" icon small @click.stop="view(item.id)" v-on="on">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>View Purchase Order</span>
          </v-tooltip>
          <v-tooltip color="dark" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mr-2" color="warning" v-bind="attrs" icon small @click.stop="edit(item.id)" v-on="on">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit Purchase Order</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-pagination v-model="currentPage" :length="lastPage" :total-visible="10" :disabled="disabled"></v-pagination>
    </v-card>
  </v-col>
</template>

<script>
import BaseColumn from "@/components/base/BaseColumn.vue";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "PurchaseOrderList",
  data() {
    return {
      headers: [
        { text: "No.Purchase Order", value: "no_po" },
        { text: "Supplier", value: "supplier.name" },
        { text: "Branch", value: "branch.name" },
        { text: "Order Date", value: "purchase_date" },
        { text: "Grand Total", value: "grand_total" },
        { text: "Status", value: "status" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      disabled: false,
      loading: false,
      loading_download: false,
      branch: [],
      status: [
        { text: "ALL", value: "" },
        { text: "ON PROGRESS", value: "ONPROGRESS" },
        { text: "DONE", value: "DONE" },
        { text: "CANCEL", value: "CANCEL" },
      ],
      search: {
        from_date: `${new Date().getFullYear()}-${("0" + (new Date().getMonth() + 1)).slice(-2)}-01`,
        end_date: new Date().toJSON().slice(0, 10),
        search: null,
        status: "",
      },
    };
  },

  methods: {
    ...mapMutations("purchase_order", ["CLEAR_STATE", "SET_PURCHASE_ORDERS", "SET_PURCHASE_ORDER", "SET_CURRENT_PAGE"]),
    sumField(key) {
      return this.PurchaseOrders.data.reduce((a, b) => a + (b[key] || 0), 0)
    },
    async init() {
      this.loading = true;
      this.disabled = true;
      let params = {
        page: this.page,
        status: this.search.status,
        search: this.search.search,
        branch_id: this.search.branch_id,
        from_date: this.search.from_date,
        end_date: this.search.end_date,
      };

      await this.$axios
        .get("/transaction/purchases", {
          params: params,
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.SET_PURCHASE_ORDERS(data.purchase_orders);
          this.loading = false;
          this.disabled = false;
        });
    },

    async getBranch() {
      await this.$axios
        .get("/master/branches", {
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.branch = data.branch.data;
        });
    },

    async edit(id) {
      this.loading = true;
      await this.$axios
        .get("/transaction/purchases/" + id, {
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          console.log(data);
          this.SET_PURCHASE_ORDER(data.purchase_orders);
          this.loading = false;
          this.$router.push("/purchase-order/edit");
        })
        .catch(() => {
          this.loading = true;
        });
    },

    view(id) {
      this.$router.push("/purchase-order/view/" + id);
    },

    searching() {
      this.page = 1;
      this.init();
    },
    clear() {
      this.page = 1;
      this.search = {
        status: "",
        search: "",
        branch_id: "",
        from_date: `${new Date().getFullYear()}-${("0" + (new Date().getMonth() + 1)).slice(-2)}-01`,
        end_date: new Date().toJSON().slice(0, 10),
      };
      this.init();
    },
  },

  components: {
    BaseColumn,
  },

  created() {
    this.init();
    this.getBranch();
  },

  watch: {
    currentPage(newValue) {
      this.page = newValue;
      this.init();
    },
  },
  computed: {
    ...mapGetters("purchase_order", {
      PurchaseOrders: "PurchaseOrders",
    }),

    ...mapGetters("auth", {
      ROLE: "Role",
    }),

    currentPage: {
      get() {
        return this.PurchaseOrders.current_page;
      },
      set(val) {
        return this.$store.commit("purchase_order/SET_CURRENT_PAGE", val);
      },
    },
    lastPage: {
      get() {
        return this.PurchaseOrders.last_page;
      },
    },
  },
};
</script>
<style scoped>
::v-deep .v-data-table-header {
  background-color: #ebebeb59;
}

::v-deep th {
  color: #000 !important;
}
</style>